import axios from 'axios';
import { apiBaseUrl } from '../config/api_config';

const axiosInstance = axios.create({
    baseURL: apiBaseUrl,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    }
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('haseela_marketerToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    async (response) => {
        const refreshedToken = response.headers['x-refreshed-token'];
        if (refreshedToken) {
            localStorage.setItem('haseela_marketerToken', refreshedToken);
        }
        return response;
    },
    async (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            const errorMessage = error.response?.data?.detail || '';
            const isTokenExpired = errorMessage.includes('expired') ||
                                 errorMessage.includes('Invalid token') ||
                                 errorMessage.includes('Missing authentication token');

            if (isTokenExpired) {
                localStorage.removeItem('haseela_marketerToken');
                window.dispatchEvent(new CustomEvent('auth:logout'));
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
